import React from "react";
import { datumNL } from "@/lib/datumNL";

export const geldigeDatum = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v || "") && Number(v.slice(0, 4)) >= 2000 && Number(v.slice(0, 4)) <= 2100 && !Number.isNaN(Date.parse(v));

// v19-N6 F2: een nieuw gekozen datum ligt vanaf vandaag (NL); een al opgeslagen datum in het verleden mag blijven staan.
export const vandaagNL = () => datumNL();
export const minDatum = (opgeslagen) => { const t = vandaagNL(); return opgeslagen && opgeslagen < t ? opgeslagen : t; };
export const teVroeg = (v, opgeslagen) => !!v && v < vandaagNL() && v !== (opgeslagen || "");
export const TE_VROEG = "Kies vandaag of een latere datum.";

// Gedeeld datumveld: native <input type="date"> (OS-kiezer op telefoon, geen popover/portal). Waarde = "yyyy-MM-dd" of "".
export const DatumVeld = ({ value, onChange, testid, className = "", min, "aria-label": ariaLabel }) => (
  <input type="date" data-testid={testid} aria-label={ariaLabel} value={value || ""} min={min}
    onChange={(e) => onChange(e.target.value)}
    className={`w-full min-h-[44px] px-3 py-2.5 rounded-md border border-zinc-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm text-zinc-900 ${className}`} />
);
